import { Select, SelectItem } from './ui/select'

export function BeanInput({ ingredientName, value, onChange, placeholder = 'Value' }: {
  ingredientName?: string; value: string; onChange: (v: string) => void; placeholder?: string
}) {
  const n = (ingredientName ?? '').toLowerCase()
  const cls = 'field'
  if (n === 'boolean') {
    return (
      <Select value={value} onValueChange={onChange} placeholder="—">
        <SelectItem value="true">true</SelectItem>
        <SelectItem value="false">false</SelectItem>
      </Select>
    )
  }
  const inputType =
    n === 'integer'  ? 'number' :
    n === 'float'    ? 'number' :
    n === 'date'     ? 'date' :
    n === 'datetime' ? 'datetime-local' :
    n === 'email'    ? 'email' :
    n === 'url'      ? 'url' :
    'text'
  const step = n === 'float' ? '0.001' : n === 'integer' ? '1' : undefined
  return (
    <input type={inputType} step={step} value={value} onChange={e => onChange(e.target.value)}
      placeholder={placeholder} className={cls} />
  )
}
